import { ScaleLoader } from "react-spinners";

export default function ButtonLoading() {
  return (
    <div style={{ margin: "0 auto", textAlign: "center" }}>
      <ScaleLoader color="#fff " height={18} />
    </div>
  );
}
